import { buildQueryString } from '../utils/queryString'
import { CALL_API } from '../middleware/api'

/**
 * Acciones del listado de **costos** (H7, Fase 6).
 * ============================================================================
 *
 * Hasta ahora, `/configuration/costs` usaba **las mismas acciones y el mismo
 * trozo del store** que `/configuration/prices`: la única diferencia era el
 * `type` que cada pantalla añadía al llamar. Eso hacía que la búsqueda de una
 * se arrastrara a la otra y que la respuesta que llegara la última ganase.
 *
 * Estas acciones son las mismas, con **tipos propios**, para que los dos
 * listados tengan estado independiente. El endpoint sigue siendo el mismo
 * —`formulas/`— porque en el backend sí es el mismo recurso: lo que separamos
 * es el estado del cliente, no el modelo.
 *
 * `type: 'COST'` se fija **aquí** en vez de en la pantalla. Antes lo ponía cada
 * punto de llamada, que es como se acaba con un `type` puesto por descuido.
 */

export const CONFIGCOST_LIST_REQUEST = 'CONFIGCOST_LIST_REQUEST'
export const CONFIGCOST_LIST_SUCCESS = 'CONFIGCOST_LIST_SUCCESS'
export const CONFIGCOST_LIST_FAILURE = 'CONFIGCOST_LIST_FAILURE'

export const CONFIGCOST_DETAIL_REQUEST = 'CONFIGCOST_DETAIL_REQUEST'
export const CONFIGCOST_DETAIL_SUCCESS = 'CONFIGCOST_DETAIL_SUCCESS'
export const CONFIGCOST_DETAIL_FAILURE = 'CONFIGCOST_DETAIL_FAILURE'

export const UPDATE_CONFIGCOST_FILTERS = 'UPDATE_CONFIGCOST_FILTERS'
export const CONFIGCOST_UPDATE_REQUEST = 'CONFIGCOST_UPDATE_REQUEST'
export const CONFIGCOST_UPDATE_SUCCESS = 'CONFIGCOST_UPDATE_SUCCESS'
export const CONFIGCOST_UPDATE_FAILURE = 'CONFIGCOST_UPDATE_FAILURE'

export const CONFIGCOST_DELETE_REQUEST = 'CONFIGCOST_DELETE_REQUEST'
export const CONFIGCOST_DELETE_SUCCESS = 'CONFIGCOST_DELETE_SUCCESS'
export const CONFIGCOST_DELETE_FAILURE = 'CONFIGCOST_DELETE_FAILURE'

export const CONFIGCOST_CREATE_REQUEST = 'CONFIGCOST_CREATE_REQUEST'
export const CONFIGCOST_CREATE_SUCCESS = 'CONFIGCOST_CREATE_SUCCESS'
export const CONFIGCOST_CREATE_FAILURE = 'CONFIGCOST_CREATE_FAILURE'

export const SELECT_CONFIGCOST = 'SELECT_CONFIGCOST'
export const RESET_CONFIGCOST = 'RESET_CONFIGCOST'

/** Nombres que espera la fábrica del reducer. */
export const TIPOS_COSTO = {
  LISTA_PETICION: CONFIGCOST_LIST_REQUEST,
  LISTA_EXITO: CONFIGCOST_LIST_SUCCESS,
  LISTA_FALLO: CONFIGCOST_LIST_FAILURE,
  DETALLE_PETICION: CONFIGCOST_DETAIL_REQUEST,
  DETALLE_EXITO: CONFIGCOST_DETAIL_SUCCESS,
  DETALLE_FALLO: CONFIGCOST_DETAIL_FAILURE,
  ACTUALIZAR_FILTROS: UPDATE_CONFIGCOST_FILTERS,
  EDICION_PETICION: CONFIGCOST_UPDATE_REQUEST,
  EDICION_EXITO: CONFIGCOST_UPDATE_SUCCESS,
  EDICION_FALLO: CONFIGCOST_UPDATE_FAILURE,
  BORRADO_PETICION: CONFIGCOST_DELETE_REQUEST,
  BORRADO_EXITO: CONFIGCOST_DELETE_SUCCESS,
  BORRADO_FALLO: CONFIGCOST_DELETE_FAILURE,
  CREACION_EXITO: CONFIGCOST_CREATE_SUCCESS,
  CREACION_FALLO: CONFIGCOST_CREATE_FAILURE,
  SELECCIONAR: SELECT_CONFIGCOST,
  REINICIAR: RESET_CONFIGCOST,
  MOSTRAR_MENSAJE: 'SHOW_MESSAGE',
  OCULTAR_MENSAJE: 'HIDE_MESSAGE'
}

export function getConfigCostList(params = {}) {
  let url = 'formulas/'
  const qs = buildQueryString({ ...params, type: 'COST' })
  if (qs) url += `?${qs}`

  return {
    [CALL_API]: {
      method: 'GET',
      localAPI: false,
      endpoint: url,
      authenticated: true,
      extra: params,
      types: [
        CONFIGCOST_LIST_REQUEST,
        CONFIGCOST_LIST_SUCCESS,
        CONFIGCOST_LIST_FAILURE
      ]
    }
  }
}

export function updateConfigCostFilters(data) {
  return dispatch => dispatch({ type: UPDATE_CONFIGCOST_FILTERS, data })
}

export function selectConfigCost(obj) {
  return dispatch => dispatch({ type: SELECT_CONFIGCOST, data: obj })
}

export function resetConfigCost() {
  return dispatch => dispatch({ type: RESET_CONFIGCOST })
}

export function configCostDelete(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      localAPI: false,
      endpoint: `formulas/${id}/`,
      authenticated: true,
      types: [
        CONFIGCOST_DELETE_REQUEST,
        CONFIGCOST_DELETE_SUCCESS,
        CONFIGCOST_DELETE_FAILURE
      ]
    }
  }
}
